import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var __jsx = React.createElement;
import React, { useRef, useEffect } from "react";
import "./Modal.css";
import { useModal } from "./ModalManager";
import { CDN_LINK } from "@globalConfig";
import { Icon } from "@syarahtech/ui";
var Modal = function Modal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    children = _ref.children,
    screens = _ref.screens,
    modalDesign = _ref.modalDesign,
    _ref$customClassName = _ref.customClassName,
    customClassName = _ref$customClassName === void 0 ? undefined : _ref$customClassName,
    _ref$haveClose = _ref.haveClose,
    haveClose = _ref$haveClose === void 0 ? true : _ref$haveClose,
    _ref$hideTitleBar = _ref.hideTitleBar,
    hideTitleBar = _ref$hideTitleBar === void 0 ? false : _ref$hideTitleBar,
    maxHeight = _ref.maxHeight,
    zeroHeightHead = _ref.zeroHeightHead,
    maxWidth = _ref.maxWidth,
    maxHeightDesktop = _ref.maxHeightDesktop,
    maxWidthDesktop = _ref.maxWidthDesktop;
  var _useModal = useModal(),
    isClosing = _useModal.isClosing,
    expansionLevel = _useModal.expansionLevel,
    setExpansionLevel = _useModal.setExpansionLevel,
    currentScreen = _useModal.currentScreen,
    goToPreviousScreen = _useModal.goToPreviousScreen;
  var bottomSheetRef = useRef(null);
  var contentRef = useRef(null);
  var barRef = useRef(null);
  var expansionHeights = [0.5, 0.85, 0.9];
  var startY = 0;
  var currentY = 0;
  var handleTouchStart = function handleTouchStart(event) {
    startY = event.touches[0].clientY;
  };
  var handleTouchMove = function handleTouchMove(event) {
    currentY = event.touches[0].clientY;
    var deltaY = startY - currentY;

    // Only allow modal drag if user isn't scrolling inside the modal content
    if (bottomSheetRef.current) {
      var screenHeight = window.innerHeight;
      var newHeight = Math.max(Math.min(newHeight, screenHeight * expansionHeights[1]),
      // Max height (expanded)
      screenHeight * 0.1 // Minimum height (set to 10% of screen height, adjust if needed)
      );
      bottomSheetRef.current.style.height = newHeight + "px";
    }
  };
  var handleTouchEnd = function handleTouchEnd() {
    var _bottomSheetRef$curre;
    var screenHeight = window.innerHeight;
    var currentHeight = ((_bottomSheetRef$curre = bottomSheetRef.current) === null || _bottomSheetRef$curre === void 0 ? void 0 : _bottomSheetRef$curre.offsetHeight) || 0;
    if (currentHeight < screenHeight * 0.5) {
      onClose();
      return;
    }
    if (currentHeight < screenHeight * (expansionHeights[expansionLevel] - 0.1)) {
      setExpansionLevel(Math.max(0, expansionLevel - 1)); // Shrink to 25%
    } else if (currentHeight > screenHeight * (expansionHeights[expansionLevel] + 0.1)) {
      setExpansionLevel(Math.min(1, expansionLevel + 1)); // Expand to 50%
    }
    if (bottomSheetRef.current) {
      bottomSheetRef.current.style.height = screenHeight * expansionHeights[expansionLevel] + "px";
    }
  };
  useEffect(function () {
    if (isOpen && bottomSheetRef.current) {
      if (window.innerWidth > 768) {
        bottomSheetRef.current.style.height = "auto";
      } else if (!maxHeight) {
        // Only set height programmatically if no custom maxHeight is provided
        var screenHeight = window.innerHeight;
        bottomSheetRef.current.style.height = screenHeight * expansionHeights[expansionLevel] + "px";
      } else {
        // Clear any programmatically set height to let CSS take over
        bottomSheetRef.current.style.height = "";
      }
    }
  }, [isOpen, expansionLevel, maxHeight]);
  useEffect(function () {
    // Manage body scroll when modal opens/closes
    if (isOpen) {
      // Store original overflow and position
      var originalOverflow = document.body.style.overflow;
      var originalPosition = document.body.style.position;

      // Prevent body scroll with multiple approaches
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.classList.add('modal-open');
      return function () {
        // Restore original values
        document.body.style.overflow = originalOverflow || "";
        document.body.style.position = originalPosition || "";
        document.body.style.width = "";
        document.body.classList.remove('modal-open');
      };
    } else {
      // Ensure body scroll is restored when modal closes
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.classList.remove('modal-open');
    }
  }, [isOpen]);
  useEffect(function () {
    // scroll contentRef to top when screen changes
    if (contentRef !== null && contentRef !== void 0 && contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [currentScreen]);
  if (!isOpen) return null;
  var style = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    maxWidth: !modalDesign.marginAroundPercentage ? "inherit" : "".concat(100 - modalDesign.marginAroundPercentage, "%")
  }, maxHeight && {
    '--custom-max-height': maxHeight
  }), maxWidth && {
    '--custom-max-width': maxWidth
  }), maxHeightDesktop && {
    '--custom-max-height-desktop': maxHeightDesktop
  }), maxWidthDesktop && {
    '--custom-max-width-desktop': maxWidthDesktop
  });
  return /*#__PURE__*/React.createElement("div", {
    className: ["modal", isClosing && modalDesign.closeAnimation ? "closing" : undefined, customClassName === "modalHideHeader" ? "modalHideHeader" : customClassName].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content ".concat(maxHeight ? 'custom-max-height' : '', " ").concat(maxWidth ? 'custom-max-width' : '', " ").concat(maxHeightDesktop ? 'custom-max-height-desktop' : '', " ").concat(maxWidthDesktop ? 'custom-max-width-desktop' : ''),
    ref: bottomSheetRef,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: ["modal-head", zeroHeightHead ? "zeroHeight" : undefined].join(" "),
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd
  }, !hideTitleBar && /*#__PURE__*/React.createElement("div", {
    className: "modal-bar",
    ref: barRef,
    onClick: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal-head-title"
  }, currentScreen > 1 ? /*#__PURE__*/React.createElement("span", {
    style: {
      zIndex: "3"
    },
    className: "back-button",
    role: "button",
    onClick: goToPreviousScreen
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/arrow-right-black.svg",
    alt: "",
    width: 24,
    height: 24
  })) : haveClose && /*#__PURE__*/React.createElement("span", {
    className: "modal-close",
    onClick: onClose,
    role: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close",
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("h2", {
    className: "modal-head-screen-title"
  }, screens[currentScreen - 1].title || ""))), /*#__PURE__*/React.createElement("div", {
    className: ["modal-body", hideTitleBar ? "title-bar-is-hidden" : ""].join(" "),
    ref: contentRef
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: "modal-backdrop",
    onClick: onClose
  }));
};
export default Modal;